// Single source of truth for the support inbox shown in the UI (feedback
// modal, Settings, public support page, payment errors). Override per
// environment with VITE_SUPPORT_EMAIL at build time; the backend has its own
// SUPPORT_EMAIL env var for where feedback submissions are forwarded.
export const SUPPORT_EMAIL =
  (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined) || 'appsupport@ironforums.org';
